import { ContractReview, ContractReviewApplyResult } from '../../models/Entities/Contracts/ContractReview';
import { ErrorType } from '../../models/HttpError';

// Revisión de contratos con IA (spec 012, data-model.md "Estado Redux")

export interface ContractReviewListEntry {
  items: ContractReview[];
  isLoading: boolean;
  success: boolean | undefined;
  error?: ErrorType;
}

export interface ContractParametrizationEntry {
  isParameterized?: boolean; // undefined = unknown
  // Contracts 021 §2: reimportación sobre adenda nueva
  hasSettlements?: boolean | null;
  canImport?: boolean;
  importBlockedReason?: string | null;
  isLoading: boolean;
  error?: ErrorType;
}

export interface ContractReviewState {
  listByContract: Record<number, ContractReviewListEntry>;
  byId: Record<string, ContractReview>;
  parametrizationByContract: Record<number, ContractParametrizationEntry>;

  // detalle
  loadingReviewId?: string;
  failOnGettingReview: boolean;
  reviewError?: ErrorType;

  // crear
  isCreating: boolean;
  successCreating: boolean | undefined;
  createError?: ErrorType;
  lastCreatedReviewId?: string;

  // decisión
  decidingFindingIds: number[];
  decisionErrors: Record<number, ErrorType>;
  isBulkDeciding: boolean;
  bulkError?: ErrorType;

  // aplicar
  isApplying: boolean;
  applyResult?: ContractReviewApplyResult;
  applyError?: ErrorType;

  // deshacer (spec 015)
  undoingFindingIds: number[];
  undoErrors: Record<number, ErrorType>;
  isUndoing: boolean;
  undoResult?: ContractReviewApplyResult;
  undoError?: ErrorType;
}

export const ContractReviewUnloadState: ContractReviewState = {
  listByContract: {},
  byId: {},
  parametrizationByContract: {},

  loadingReviewId: undefined,
  failOnGettingReview: false,
  reviewError: undefined,

  isCreating: false,
  successCreating: undefined,
  createError: undefined,
  lastCreatedReviewId: undefined,

  decidingFindingIds: [],
  decisionErrors: {},
  isBulkDeciding: false,
  bulkError: undefined,

  isApplying: false,
  applyResult: undefined,
  applyError: undefined,

  undoingFindingIds: [],
  undoErrors: {},
  isUndoing: false,
  undoResult: undefined,
  undoError: undefined
};
